<template>
    <div class="container">
        <div class="shop-inner">
            <Filters
                :mainTypes="mainTypes"
                :categories="categories"
                :fetchProducts="fetchProducts"
                :formFields="formFields"
                :priceFilters="priceFilters"
                :subCategories="subCategories"/>

            <SContent
                :products="products"
                :is-loading="isLoading"
                :order-items="orderItems"
                :selected-order-by="selectedOrderBy"
            />
        </div>
    </div>
</template>

<script>
import Filters from "./Filters.vue";
import ProductItem from "./ProductItem.vue";
import SContent from "./SContent";

export default {
    components: {SContent, ProductItem, Filters},
    data() {
        return {
            isLoading: false,
            products: [],
            mainTypes: [],
            categories: [],
            subCategories: [],
            formFields: [],
            priceFilters: [],
            selectedOrderBy: 'created_new_to_old',
            orderItems: {
                price_max_to_min: $trans('main.Price highest'),
                price_min_to_max: $trans('main.Price - lowest'),
                created_new_to_old: $trans('main.Created newest'),
                created_old_to_new: $trans('main.Created oldest'),
            },
        }
    },
    methods: {
        fetchProducts() {
            this.isLoading = true;

            axios.get(window.location.href.replace('/products', '/products/json')).then(res => {
                this.products = res.data.products;
                this.mainTypes = res.data.mainTypes;
                this.formFields = res.data.formFields;
                this.priceFilters = res.data.priceFilters ?? [];
                let categories = [];
                let subCategories = [];

                res.data.mainTypes.forEach(mainType => {
                    categories = [...categories, ...mainType.categories];

                    mainType.categories.forEach(category => {
                        subCategories = [...subCategories, ...category.sub_categories];
                    })
                });

                this.categories = categories;
                this.subCategories = subCategories;
                this.isLoading = false;
                this.updateShopHead();
            })
        },
        onChangeHandler(key, value, needRequest = true) {
            const selectedFilters = this.selectedFilters;
            selectedFilters[key] = value;
            const queryString = new URLSearchParams(selectedFilters).toString();
            let url = '/' + document.querySelector('html').getAttribute('lang');
            url = url + '/products?' + queryString;

            history.pushState({}, null, url);
            this.updateShopHead();

            if (needRequest) {
                this.fetchProducts();
            }
        },
        updateShopHead() {
            const config = window.shopCategoryHead;

            if (!config) {
                return;
            }

            const filters = this.selectedFilters;
            const subCategoryId = Number(filters.sub_category_id) || null;
            const categoryId = Number(filters.category_id) || null;
            const mainTypeId = Number(filters.main_type_id) || null;
            const header = config.categories?.[subCategoryId]
                ?? config.categories?.[categoryId]
                ?? config.mainTypes?.[mainTypeId]
                ?? config.default;

            if (!header) {
                return;
            }

            const titleEl = document.querySelector('.shop-head-title');
            const descriptionEl = document.querySelector('.shop-head-description');

            if (titleEl) {
                titleEl.textContent = header.title;
            }

            if (descriptionEl) {
                descriptionEl.textContent = header.description;
            }
        },
    },
    watch: {
        selectedOrderBy(val, oldVal) {
            if (oldVal || (!oldVal && !Object.keys(this.selectedFilters).length)) {
                this.onChangeHandler('order_by', val, true)
            }
        }
    },
    mounted() {
        this.stripLegacySentinelPrices();
        this.fetchProducts();
        this.updateShopHead();

        const selectedFilters = this.selectedFilters;

        this.selectedOrderBy = selectedFilters?.order_by ?? 'created_new_to_old';

        window.addEventListener('popstate', this.updateShopHead);
    },
    beforeDestroy() {
        window.removeEventListener('popstate', this.updateShopHead);
    },
};
</script>
